import { Stack } from '@mui/material';
import { IEmailStatisticsDTO } from 'wisestep-api';
import { WsTypography, WsTypoVariants, WsTypoColors } from 'wisestep-base';
interface InboxStatsProps {
  inboxStats: IEmailStatisticsDTO;
}
export const InboxStats = ({ inboxStats }: InboxStatsProps) => (
  <Stack spacing={1} alignItems="center">
    <Stack direction="row" spacing={3}>
      <Stack alignItems="center" spacing={1}>
        <WsTypography
          hoverText="Total emails"
          variant={WsTypoVariants.BODY1}
          color={WsTypoColors.WHITE}
        >
          Total Emails
        </WsTypography>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.WHITE}>
          {inboxStats.total ?? 0}
        </WsTypography>
      </Stack>
      <Stack alignItems="center" spacing={1}>
        <WsTypography
          hoverText="Read emails"
          variant={WsTypoVariants.BODY1}
          color={WsTypoColors.WHITE}
        >
          Read Emails
        </WsTypography>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.WHITE}>
          {inboxStats.read ?? 0}
        </WsTypography>
      </Stack>
      <Stack alignItems="center" spacing={1}>
        <WsTypography
          hoverText="unread emails"
          variant={WsTypoVariants.BODY1}
          color={WsTypoColors.WHITE}
        >
          UnRead Emails
        </WsTypography>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.WHITE}>
          {inboxStats.unread ?? 0}
        </WsTypography>
      </Stack>
    </Stack>
    <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.YELLOW}>
      We are loading emails based on your configured sync duration.
    </WsTypography>
    <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.YELLOW}>
      Beta Release
    </WsTypography>
  </Stack>
);
